import { IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ICommentsDatasource } from '../../../../comments/datasources/comments_datasource';
import { FeedbackSuggestedPlanModel } from '../../../../suggestions/components/plan_feedback/models/feedback_suggested_plan_model';

angular
  .module('capability-ng-academic-planner')
  .service(
    'removeCourseFlagCommand',
    function removeCourseFlagCommandDefinition(
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel,
      ngCommentsDatasource: ICommentsDatasource,
      log: any
    ) {
      return defineCommandORM('removeCourseFlagCommand', function removeCourseFlagCommand(deferred, commentId: number) {
        const url = `/academicplan/suggested_plan/${ngFeedbackSuggestedPlanModel.read().id}/comment/${commentId}`;
        $http
          .delete(url)
          .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
            ngCommentsDatasource.del(commentId);
            deferred.resolve();
          })
          .catch((e: ng.IHttpPromiseCallbackArg<any>) => {
            log.issue('failed to remove flag for the course');
            deferred.reject(e.data);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/course_flag_dialog/commands/remove_course_flag_command.ts